import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Clock, ChevronRight, Star } from 'lucide-react';
import { motion } from 'framer-motion';

const TempleCard = ({ temple, index }) => {
  return (
    <motion.div 
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: index * 0.1 }}
      className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl border border-stone-100 transition-all duration-300 hover:-translate-y-1 flex flex-col h-full"
    >
      <div className="relative h-56 overflow-hidden bg-stone-100">
        <img 
          src={temple.image || 'https://via.placeholder.com/600x400?text=Temple'} 
          alt={temple.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
        <div className="absolute inset-x-4 bottom-4 flex justify-between items-end">
          <h3 className="text-xl font-bold text-white drop-shadow-md group-hover:text-saffron-300 transition-colors">
            {temple.name}
          </h3>
          <div className="flex items-center space-x-1 bg-black/40 backdrop-blur-md px-2 py-1 rounded-md">
            <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
            <span className="text-white text-xs font-bold">{temple.rating}</span>
          </div>
        </div>
      </div>

      <div className="p-5 flex-grow flex flex-col">
        {/* Badges/Icons row */}
        <div className="flex flex-wrap items-center gap-y-2 text-xs font-medium text-stone-600 mb-3 border-b border-stone-50 pb-3">
          <div className="flex items-center space-x-1.5 mr-4 bg-stone-50 px-2.5 py-1 rounded-md text-stone-600">
            <MapPin className="w-3.5 h-3.5 text-saffron-600" />
            <span className="truncate max-w-[120px]" title={temple.location}>{temple.location}</span>
          </div>
          <div className="flex items-center space-x-1.5 bg-saffron-50 px-2.5 py-1 rounded-md text-saffron-700">
            <Clock className="w-3.5 h-3.5" />
            <span>{temple.timing}</span>
          </div>
        </div>

        {/* Description */}
        <p className="text-stone-600 text-sm leading-relaxed mb-6 line-clamp-3">
          {temple.description}
        </p>

        {/* Action Button at bottom */}
        <div className="mt-auto">
          <Link 
            to={`/temple/${temple.id}`}
            className="inline-flex items-center space-x-2 text-saffron-600 font-semibold text-sm hover:text-saffron-700 transition-colors group/btn"
          >
            <span>विस्तृत इतिहास पढ़ें</span>
            <ChevronRight className="w-4 h-4 transform group-hover/btn:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default TempleCard;
